export const statusNotificationList = (state, rootState) => {
	return state.statusNotificationList;
}

export const statusCount = (state, rootState) => {
	return state.statusCount;
}

export const quoteStatuses = (state, rootState) => {
  return state.quoteStatuses;
}

export const whatsappTemplates = (state, rootState) => {
	return state.whatsappTemplates;
}

/*export const objVendorEdit = (state, rootState) => {
	return state.objVendorEdit;
}

export const vendorManufacturers = (state, rootState) => {
  return state.vendorManufacturers;
}

export const vendorManufacturerRanges = (state, rootState) => {
	return state.vendorManufacturerRanges;
}

export const vendorManufacturerLinks = (state, rootState) => {
	return state.vendorManufacturerLinks
}

export const objVendorSelectEdit = (state, rootState) => {
	return state.objVendorSelectEdit;
}

export const objAppRanges = (state, rootState) => {
	return state.objAppRanges;
}

export const vendorsIni = (state, rootState) => {
	return state.vendorsIni;
}*/
